import React, { useState } from 'react';
import { OrderTitles } from './OrderTitles';
import { useDispatch, useSelector } from 'react-redux';
import { OrderContainer } from './OrderContainer';
import { EmptyPage } from '../../pages/EmptyPage';
import { AddNewOrder } from './AddNewOrder';
import { createFilterOrdersFunc, createSearchOrdersFunc, createSortOrdersFunc, getZoomSettings, regularizeOrders } from '../../redux/settingSlice';
import { generateGridTemplateColumns } from '../../helpers';
import { setSort } from '../../redux/orderSlice';
import { AverageCheque } from './AverageCheque';
import { OrdersCount } from './OrdersCount';
import { CancelOrdersCount } from './CancelOrdersCount';
import { ModernOrdersCount } from './ModernOrdersCount';
import { OrdersTotalSum } from './OrdersTotalSum';
import { OrdersClearSum } from './OrdersClearSum';


export const Orders = ({activeMonths, searchSets, titles, colorState}) => {
    const ordersList = useSelector((state) => state.orders.list);
    const dispatch = useDispatch();

    const isOrderCreating = useSelector((state) => state.orders.isOrderCreating);
    const isLightTheme = useSelector((state) => state.app.isLightTheme);

    const titleSizes = useSelector((state) => state.orders.orderTitles);
    const gridTemplateColumns = generateGridTemplateColumns(titleSizes, titles);

    const filters = useSelector((state) => state.orders.filter);
    const depsIds = useSelector((state) => state.orders.deps);
    //filters
    const monthFilter = (o) => !depsIds.length ? activeMonths.some(m => m.timestamp === o.details.monthStamp) : true;
    const userFilter = createFilterOrdersFunc(filters);
    const searchFn = createSearchOrdersFunc(searchSets);
    const depsFilter = (o) => depsIds.length ? depsIds.some(id => id === o._id) : true;
    //
    //sort
    const orderSort = useSelector((state) => state.orders.sort);

    const setSortHandler = (sortValue) => {
        localStorage.setItem('orderSort', JSON.stringify(sortValue));
        dispatch(setSort(sortValue));
    }
    const sortFn = createSortOrdersFunc(orderSort);
    const visibleOrders = ordersList.map(regularizeOrders)
    .filter(monthFilter)
    .filter(userFilter)
    .filter(searchFn)
    .filter(depsFilter)
    .sort(sortFn);
    
    const [isResizeTitles, setResizeTitles] = useState(false);

    const ZOOM_MIN = 0.5;
    const ZOOM_MAX = 2;
    const savedZoom = getZoomSettings(ZOOM_MIN, ZOOM_MAX);
    const [zoom, setZoom] = useState(savedZoom);

    const setZoomHandler = (value) => {
        localStorage.setItem('zoomState', String(zoom));
        setZoom(value);
    }
    const wheelHandler = (evt) => {
        if (!evt.ctrlKey || isResizeTitles) return;
        const ZOOM_STEP = 0.1;
        const multi = evt.deltaY > 0 ? -1 : 1;
        const newZoom = zoom + ZOOM_STEP*multi;
        if (newZoom <= ZOOM_MIN) {
            setZoomHandler(ZOOM_MIN);
        } else if (newZoom >= ZOOM_MAX) {
            setZoomHandler(ZOOM_MAX);
        } else {
            setZoomHandler(newZoom);
        }
    }

    return (
        <div className="orders-container">
            <AverageCheque orders={visibleOrders} />
            <OrdersCount orders={visibleOrders} />
            <CancelOrdersCount orders={visibleOrders} />
            <ModernOrdersCount orders={visibleOrders} />
            <OrdersTotalSum orders={visibleOrders} />
            <OrdersClearSum orders={visibleOrders} />
            <div className="orders" onWheel={wheelHandler} id="orders" style={{transform: `scale(${zoom})`}} onContextMenu={(evt) => evt.preventDefault()}>
                <OrderTitles sort={orderSort} setSort={setSortHandler} isResize={isResizeTitles} setResize={setResizeTitles} titles={titles} isLightTheme={isLightTheme} />
                <div className="orders-list">
                    {isOrderCreating && <AddNewOrder titles={titles} gridTemplateColumns={gridTemplateColumns} />}
                    {visibleOrders.length ? (
                        visibleOrders.map((o) => (
                            <OrderContainer colorState={colorState} zoom={zoom} gridTemplateColumns={gridTemplateColumns} key={o._id} titles={titles} data={o} />
                        ))
                    ) : (
                        <EmptyPage message="Нет заявок" />
                    )}
                    <div id='order-menu-root'></div>
                </div>
            </div>
        </div>
    );
};
